module.exports = __webpack_public_path__ + "img/4.08.thmb.xs.4df90a63.jpg";